import { Box, Button, Text } from '@rbilabs/universal-components';

import { primitive } from 'styles/constants/primitives';
import { isWeb } from 'utils/environment';
export const Title = Text.withConfig({
  bold: true,
  textAlign: 'center',
  fontSize: 'sm',
});

export const TitlePointDivider = Text.withConfig({
  fontSize: 'xl',
  paddingTop: isWeb ? undefined : { base: '$1', md: '$0' },
});

export const DescriptionPart = Text.withConfig({
  paddingTop: isWeb ? undefined : { base: '$0.5', md: '$0' },
});

export const Container = Box.withConfig<{ hasTitle?: boolean }>(p => ({
  flexDir: 'row',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '$0.5',
  paddingBottom: p.hasTitle ? '0' : '$1.5',
}));

export const ModalBodyContainer = Box.withConfig({
  maxWidth: 320,
});

export const ModalItemContainer = Box.withConfig({
  marginTop: '$4',
});

export const ModalSubtitleContainer = Box.withConfig({
  _text: {
    fontWeight: 'bold',
  },

  flexDirection: 'row',
});

export const IconContainer = Button.withConfig({
  variant: 'ghost',
  padding: '$1',
});

export const DesktopContainer = Box.withConfig({
  borderBottomWidth: 1,
  borderBottomColor: primitive.$blackOpacity10,
});
